import { useState, useMemo } from "react";

type Optional<T> = T | undefined;

interface UsePaperPositionResult {
  rect: Optional<DOMRect>;
  setRect: (rect: DOMRect) => void;
  isTopVariant: boolean;
}

const APPROX_ITEM_HEIGHT = 40;

export const usePaperPosition = (childrenCount: number): UsePaperPositionResult => {
  const [rect, setRect] = useState<Optional<DOMRect>>(undefined);

  const isTopVariant = useMemo(() => {
    if (!rect) {
      return false;
    }
    const { top, height } = rect;
    // eslint-disable-next-line no-restricted-globals
    const bottom = window?.innerHeight - top - height;
    return bottom - (childrenCount + 1) * APPROX_ITEM_HEIGHT < 0 && top > bottom;
  }, [rect, childrenCount]);

  return { rect, setRect, isTopVariant };
};
